import React from "react";
import {
  SimpleShowLayout,
  TextField,
  NumberInput,
  TextInput
} from "react-admin";

const FormTab = (props) => {
  return (
    <SimpleShowLayout {...props}>
      <TextField source="baseball.id" label="ID" />
      <NumberInput source="baseball.seasonWins" label="Season Wins" />
      <NumberInput source="baseball.seasonLosses" label="Season Losses" />
      <NumberInput source="baseball.seasonTies" label="Season Ties" />
      <NumberInput
        source="baseball.seasonPercentWins"
        label="Season Percent Wins"
      />
      <NumberInput source="baseball.districtWins" label="District Wins" />
      <NumberInput source="baseball.districtLosses" label="District Losses" />
      <NumberInput source="baseball.districtTies" label="District Ties" />
      <NumberInput
        source="baseball.districtPercentWins"
        label="District Percent Wins"
      />
      <NumberInput source="baseball.homeWins" label="Home Wins" />
      <NumberInput source="baseball.homeLosses" label="Home Losses" />
      <NumberInput source="baseball.homeTies" label="Home Ties" />
      <NumberInput source="baseball.roadWins" label="Road Wins" />
      <NumberInput source="baseball.roadLosses" label="Road Losses" />
      <NumberInput source="baseball.roadTies" label="Road Ties" />
      <TextInput source="baseball.streak" label="Streak" />
      <NumberInput source="baseball.differential" label="Differential" />

      <NumberInput source="baseball.teamGameCount" label="Team Game Count" />
    </SimpleShowLayout>
  );
};

export default FormTab;
